module.exports = __webpack_public_path__ + "img/Centiva_Dark.7e00308b.svg";